import React, { useEffect, useMemo, useRef, useState } from 'react';
import { IoClose } from "react-icons/io5";
import { BrowserView, isMobile, isTablet } from 'react-device-detect';
import { fmesh, foundFeature, fmeshPoints } from '../../core/globalVariables.js';
import Drawer from 'react-modern-drawer';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import Chart from "chart.js/auto";
import { MdOutlineAddToPhotos } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";
import { MdOutlineLayers } from "react-icons/md";
import ClickedInfoRealm from "./../menus/leftMenuComponents/clickedInfoRealm.js";
import MetricItem from "../menus/leftMenuComponents/MetricItem.js";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { Tb3DCubeSphere } from 'react-icons/tb';
import { BiSolidColor } from "react-icons/bi";
import ValueDropdown from '../../ui/menus/leftMenuComponents/ValueDropdown.js'
import KeyDropdown from '../../ui/menus/leftMenuComponents/keyDropdown.js';
import YearDropdown from '../../ui/menus/leftMenuComponents/yearDropdown.js';
import fetchMetricDataSummaryKey from '../../dataManagement/fetchMetricDataSummaryKey.js';
import fetchMetricDataSummaryNumeric from '../../dataManagement/fetchMetricDataSummaryNumeric.js'
import { IoIosInformationCircleOutline } from "react-icons/io";
import { MdBarChart } from "react-icons/md";
import { FaRegFileImage } from "react-icons/fa";
import { CgNotes } from "react-icons/cg";
import { IoFilter } from "react-icons/io5";
import MapMetaOrFeatureDataSimple from "../menus/leftMenuComponents/MapMetaOrFeatureDataSimple.js";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import useFeatureMarkers from '../../ui/menus/leftMenuComponents/clickedPolygonMarkers.js';

const ClickedInfo = ({
  isVisible,
  polygonCustomLayerRef,
  clickedInfoHeader,
  globalState,
  globalRefs,
  longstandingGeoJSONRef,
  originalGeoJSONforComparingRef,
  ResetMap,
}) => {
  const [modalOtherOriginal, setmodalOtherOriginal] = useState(null);
  const [modalOtherAmended, setmodalOtherAmended] = useState(null);
  const [modalSkylarkId, setModalSkylarkId] = useState(null);
  const [selectedMetricValue, setSelectedMetricValue] = useState(null);
  const [selectedKeyValue, setSelectedKeyValue] = useState(null);
  const [landKeySelectedKeyColourOriginal, setlandKeySelectedKeyColourOriginal] = useState(null);
  const [landKeySelectedKeyColourAmended, setlandKeySelectedKeyColourAmended] = useState(null);
  const [totalSumMetric, setTotalSumMetric] = useState(0);
  const [totalSumMetricOriginal, setTotalSumMetricOriginal] = useState(0);
  const [totalSumsValue, setTotalSumsValue] = useState(null);
  const [totalSumsValueOriginal, setTotalSumsValueOriginal] = useState(null);
  const [multilayerDetails, setMultilayerDetails] = useState('');
  const [multilayerOriginalGroupDetails, setMultilayerOriginalGroupDetails] = useState('');
  const [multiGroupDetails, setMultilayerGroupDetails] = useState('');
  const [multilayerOriginalParcelDetails, setMultilayerOriginalParcelDetails] = useState('');
  const [multiParcelDetails, setMultilayerParcelDetails] = useState('');
  const [valuesFromGroupData, setValuesFromGroupData] = useState('');
  const [moreThanOneLayer, setMoreThenOneLayer] = useState(false);
  const [moreThanOnePolygonSelected, setMoreThenOnePolygonSelected] = useState(false);
  const [numericAggregationMethod, setNumericAggregationMethod] = useState("sum");
  const totalLineChartRef = useRef(null);
  let noData = true;

  const setSelectedMetric = globalState.setSelectedMetric;
  const selectedKey = globalState.selectedKey;
  const setSelectedKey = globalState.setSelectedKey;
  const universalDataLoaded = globalState.universalDataLoaded;
  const isModifying = globalState.isModifying;
  const TotalsRef = globalRefs.TotalsRef;
  const currentMapIdRef = globalRefs.currentMapIdRef;
  const yearsAvailable = globalState.yearsAvailable;
  let availableDates = globalState.availableDates;
  let setAvailableDates = globalState.setAvailableDates;
  const setSelectedYearEditing = globalState.setSelectedYearEditing;
  let selectedRange = globalState.selectedRange;
  let setSelectedRange = globalState.setSelectedRange;
  let selectedYearEditing = globalState.selectedYearEditing;
  let setIsVisible = globalState.setIsVisible;
  let selectedMetric = globalState.selectedMetric;
  let landKeySelectedKey = globalState.landKeySelectedKey;
  let setLayers = globalState.setLayers;
  let hasChangedKeyValue = globalState.hasChangedKeyValue;
  let multiLayerSelected = globalState.multiLayerSelected;
  let setMultiLayerSelected = globalState.setMultiLayerSelected;
  let multuLayerSelectedArray = globalState.multuLayerSelectedArray;
  let setMultuLayerSelectedArray = globalState.setMultuLayerSelectedArray;
  let greoupingSelected = globalState.greoupingSelected;
  let setGreoupingSelected = globalState.setGreoupingSelected;
  let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
  let setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
  let isRighdivrawerVisible = globalState.isRighdivrawerVisible;
  let setIsRighdivrawerVisible = globalState.setIsRighdivrawerVisible;
  let universalParcelDifferentiator = globalState.universalParcelDifferentiator
  let universalColorPaletteName = globalState.universalColorPaletteName
  let setLandKeySelectedKey = globalState.setLandKeySelectedKey
  let isRealmLeftClickedInfoVisible = globalState.isRealmLeftClickedInfoVisible
  let setIsRealmLeftClickedInfoVisible = globalState.setIsRealmLeftClickedInfoVisible
  let activeTab = globalState.activeTab;
  let setActiveTab = globalState.setActiveTab;
  let featureList = globalState.featureList;
  let setFeatureList = globalState.setFeatureList;
  let activeFeatureId = globalState.activeFeatureId;
  let setActiveFeatureId = globalState.setActiveFeatureId;
  let mapMetaData = globalState.mapMetaData;
  let layers = globalState.layers;
  let isYearRangeActive = globalState.isYearRangeOpen;
  let setIsYearRangeActive = globalState.setIsYearRangeOpen;
  let mapOverview = globalState.mapOverview;
  let numericSummary = globalState.numericSummary;
  let setNumericSummary = globalState.setNumericSummary;
  let keySummary = globalState.keySummary;
  let setKeySummary = globalState.setKeySummary;
  let globalStartDate = globalState.globalStartDate;
  let setGlobalStartDate = globalState.setGlobalStartDate;
  let globalEndDate = globalState.globalEndDate;
  let setGlobalEndDate = globalState.setGlobalEndDate;
  let setIsLoadingNewGeoJSONFromAnUpdate = globalState.setIsLoadingNewGeoJSONFromAnUpdate;
  let setAPIReportMessage = globalState.setAPIReportMessage;
  let showFilterFeatureDataSimpleTimeseriesModal = globalState.showFilterFeatureDataSimpleTimeseriesModal;
  let setShowFilterFeatureDataSimpleTimeseriesModal = globalState.setShowFilterFeatureDataSimpleTimeseriesModal;
  let setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
  let availableNumericMetrics = globalState.availableNumericMetrics;
  let setAvailableNumericMetrics = globalState.setAvailableNumericMetrics;
  let availableStringMetrics = globalState.availableStringMetrics;
  let setAvailableStringMetrics = globalState.setAvailableStringMetrics;
  let debugMode = globalState.debugMode;
  let setDebugMode = globalState.setDebugMode;
  let clickedInfoTab = globalState.clickedInfoTab;
  let setClickedInfoTab = globalState.setClickedInfoTab;

  let numericTimeAggregationMethod = globalState.numericTimeAggregationMethod;
  let setNumericTimeAggregationMethod = globalState.setNumericTimeAggregationMethod;

  let setLoadedPercentage = globalState.setLoadedPercentage;

  // 

  let LOADINGPARAM_fetchKeyData = globalState.LOADINGPARAM_fetchKeyData;
  let setLOADINGPARAM_fetchKeyData = globalState.setLOADINGPARAM_fetchKeyData;

  let LOADINGPARAM_fetchNumericData = globalState.LOADINGPARAM_fetchNumericData;
  let setLOADINGPARAM_fetchNumericData = globalState.setLOADINGPARAM_fetchNumericData;

  let mapRef = globalRefs.mapRef;

  let IsLoadingNewGeoJSONFromAnUpdate = globalState.IsLoadingNewGeoJSONFromAnUpdate;

  // toggle drawer function

  const toggleDrawer = () => {
    setIsVisible(false);
    setIsRighdivrawerVisible(!isRighdivrawerVisible);
  };

  // STRING SLIDER REQUIREMENTS

  const maxIndex = useMemo(
    () => Math.max(0, availableDates.length - 1),
    [availableDates]
  );

  const marks = useMemo(() => {
    return availableDates.reduce((acc, y, i) => {
      const date = new Date(y);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);

      acc[i] = `${day}/${month}/${year}`;

      return acc;
    }, {});
  }, [availableDates]);

  const toIsoWithOffset = (date) => {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, '0');
    const year = d.getUTCFullYear();
    const month = pad(d.getUTCMonth() + 1);
    const day = pad(d.getUTCDate());
    const hours = pad(d.getUTCHours());
    const minutes = pad(d.getUTCMinutes());
    const seconds = pad(d.getUTCSeconds());
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+00:00`;
  };

  const getFeatureIdsToPass = () => {
    const geoJSON = longstandingGeoJSONRef.current;
    const features = geoJSON?.features;
    if (!features?.length) return null;
    if (multuGroupSelectedArray.length > 1) {
      return multuGroupSelectedArray;
    }
    if (multuGroupSelectedArray.length === 0) {
      return features.map(feature => feature.skylark_id);
    }
    return null;
  };

  const offsetDateBySeconds = (dateValue, seconds) => {
    if (!dateValue) return dateValue;
    const date = new Date(dateValue);
    date.setSeconds(date.getSeconds() + seconds);
    return date.toISOString();
  };

  useEffect(() => {
    console.count("🟡 NUMERIC useEffect fired");

    const invalid =
      !selectedMetric ||
      selectedMetric === "default";

    if (invalid) {
      console.log("⛔ Numeric useEffect skipped - invalid selectedMetric:", selectedMetric);
      return;
    }

    const fetchNumericData = async () => {
      const featureIds = getFeatureIdsToPass();

      if (!featureIds || featureIds === null) {
        console.log("⛔ Numeric fetch skipped - no featureIds");
        return;
      }

      console.count("🔵 NUMERIC API call");

      setIsLoadingNewGeoJSONFromAnUpdate(true);
      setAPIReportMessage("Loading New Summary Data...");

      const numericParams = {
        id: currentMapIdRef.current,
        numericMetric: selectedMetric,
        workingLocally: globalState.workingLocally,
        devDeployment: globalState.devDeployment,
        summary: globalState.summary,
        kind: "timeseries",
        method: numericAggregationMethod,
        feature_ids: featureIds,
        timeseries_from: offsetDateBySeconds(globalStartDate, -1),
        timeseries_to: offsetDateBySeconds(globalEndDate, 1),
        timeseries_average: numericTimeAggregationMethod,
        globalRefs,
        globalState,
      };

      try {
        const numericResult =
          await fetchMetricDataSummaryNumeric(numericParams);

        if (debugMode) {
          const timestamp = new Date().toISOString();

          console.log(
            timestamp +
            " 🔢 Numeric Values Summary returned from API: " +
            numericResult
          );
        }

        const formattedResult = Object.fromEntries(
          Object.entries(numericResult).map(([metric, dates]) => [
            metric,
            Object.fromEntries(
              Object.entries(dates).map(([date, value]) => [
                date,
                Number(value.toFixed(6)),
              ])
            ),
          ])
        );

        setNumericSummary(formattedResult);

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage("");

        setLOADINGPARAM_fetchNumericData(true);
      } catch (err) {
        console.error("❌ Numeric API error:", err);

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage("");
      }
    };

    fetchNumericData();
  }, [
    multuGroupSelectedArray,
    numericAggregationMethod,
    numericTimeAggregationMethod,
    selectedMetric,
    globalStartDate,
    globalEndDate,
  ]);

  useEffect(() => {
    const invalid =
      !selectedKey ||
      selectedKey === "default" ||
      selectedYearEditing === null ||
      !longstandingGeoJSONRef.current ||
      longstandingGeoJSONRef.current === null;
    if (invalid) {
      return;
    }
    const fetchKeyData = async () => {
      const featureIds = getFeatureIdsToPass();
      if (!featureIds || featureIds === null) return;
      setIsLoadingNewGeoJSONFromAnUpdate(true)
      setAPIReportMessage('Loading New Category Summary Data...')
      const keyParams = {
        id: currentMapIdRef.current,
        keyMetric: selectedKey,
        workingLocally: globalState.workingLocally,
        devDeployment: globalState.devDeployment,
        summary: globalState.summary,
        kind: "timeseries",
        method: "count_grouped",
        feature_ids: featureIds,
        timeseries_at: selectedYearEditing,
        globalRefs,
        globalState,
      };
      try {
        const keyResult = await fetchMetricDataSummaryKey(keyParams);
        if (debugMode) {
          const timestamp = new Date().toISOString();
          console.log(timestamp + " " + "🈂️ String Values Summary returned from API: " + keyResult)
        }
        setKeySummary(keyResult);
        setIsLoadingNewGeoJSONFromAnUpdate(false)
        setAPIReportMessage('');
        // 
        setLOADINGPARAM_fetchKeyData(true)
      } catch (err) {
        console.error("Key fetch error:", err);
        setIsLoadingNewGeoJSONFromAnUpdate(false)
        setAPIReportMessage('')
      }
    };
    fetchKeyData();
  }, [
    multuGroupSelectedArray,
    selectedKey,
    selectedYearEditing,
    longstandingGeoJSONRef.current
  ]);

  useEffect(() => {
    if (polygonCustomLayerRef.current) {
      if (greoupingSelected) {
        polygonCustomLayerRef.current.greoupingSelectedExternalSet(true)
      } else {
        polygonCustomLayerRef.current.greoupingSelectedExternalSet(false)
      }
    }
  }, [greoupingSelected, polygonCustomLayerRef])

  function roundToTwoDecimals(value) {
    return typeof value === 'number' ? Math.round(value * 100) / 100 : value;
  }

  useEffect(() => {
    if (polygonCustomLayerRef.current) {
      if (!isRighdivrawerVisible) {
        polygonCustomLayerRef.current.multiLayerSelectedExternalSet(false);
        polygonCustomLayerRef.current.greoupingSelectedExternalSet(false);
        polygonCustomLayerRef.current.resetfeatureOpacities(fmesh);
        multuGroupSelectedArray.length = 0;
        multuLayerSelectedArray.length = 0;
        setMultuGroupSelectedArray([]);
        setMultuLayerSelectedArray([]);
        setMoreThenOneLayer(false);
        if (Array.isArray(multuGroupSelectedArray)) {
          multuGroupSelectedArray.forEach(skylarkId => {
            polygonCustomLayerRef.current
              .removedSkylarkIdFromsetMultuGroupSelectedArrayPoints(skylarkId);
          });
        }
        setIsRealmLeftClickedInfoVisible(false);
        setFeatureList([]);
        setActiveFeatureId(null);
      }
    }
  }, [isRighdivrawerVisible, polygonCustomLayerRef]);

  useEffect(() => {
    if (multuGroupSelectedArray) {
      if (multuGroupSelectedArray.length > 1) {
        setMoreThenOnePolygonSelected(false)
      } else {
        setMoreThenOnePolygonSelected(true)
      }
    }
  }, [multuGroupSelectedArray])

  useEffect(() => {
    if (layers.length > 0) {
      setMoreThenOneLayer(true);
    } else {
      setMoreThenOneLayer(false);
    }
  }, [layers])

  // SET SELECTED CATEGORY OR VALUE BASED ON VALIDATION & ORDER

  useEffect(() => {
    // Numeric metric validation
    if (availableNumericMetrics.length) {
      if (!selectedMetric || !availableNumericMetrics.includes(selectedMetric)) {
        const nextNumericMetric = availableNumericMetrics[0];
        setSelectedMetric(nextNumericMetric);
        setOpenNumericMetric(nextNumericMetric);
      }
    } else {
      setSelectedMetric(null);
      setOpenNumericMetric(null);
    }
    // String metric validation
    if (availableStringMetrics.length) {
      if (!selectedKey || !availableStringMetrics.includes(selectedKey)) {
        const nextStringMetric = availableStringMetrics[0];
        setSelectedKey(nextStringMetric);
        setLandKeySelectedKey(nextStringMetric);
        setOpenStringMetric(nextStringMetric);
      }
    } else {
      setSelectedKey(null);
      setOpenStringMetric(null);
    }
  }, [
    availableNumericMetrics,
    availableStringMetrics
  ]);

  useEffect(() => {
    if (selectedMetric) setOpenNumericMetric(selectedMetric);
  }, [selectedMetric]);

  useEffect(() => {
    if (selectedKey) setOpenStringMetric(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (!selectedMetric) return;
    const ctx = document.getElementById("totalMetricLineChart")?.getContext("2d");
    if (!ctx) return;
    if (totalLineChartRef.current) {
      totalLineChartRef.current.destroy();
    }
    const amendedSeries = numericSummary?.[selectedMetric] || {};
    const originalSeries = keySummary?.[selectedMetric] || {};

    const years = Object.keys(amendedSeries).sort();

    const amendedData = years.map(y => amendedSeries[y]);
    const originalData = years.map(y => originalSeries[y] ?? 0);
    totalLineChartRef.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: years,
        datasets: [
          {
            label: "Original",
            data: originalData,
            borderColor: "#808080",
            backgroundColor: "rgba(128,128,128,0.2)",
            tension: 0.2
          },
          {
            label: "Amended",
            data: amendedData,
            borderColor: "#29645D",
            backgroundColor: "rgba(41,100,93,0.2)",
            tension: 0.2
          }
        ]
      },
      options: {
        animation: false,
        responsive: true,
        plugins: {
          legend: { display: true }
        },
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }, [selectedMetric, longstandingGeoJSONRef, originalGeoJSONforComparingRef, selectedYearEditing]);

  const tabIcons = {
    TOTAL: <MdOutlineAddToPhotos />,
    GROUP: <CgMenuGridO />,
    MULTILAYER: <MdOutlineLayers />
  };

  const convertCoordinates = (geometry) => {
    if (geometry.type === 'Point') return geometry.coordinates;
    if (geometry.type === 'Polygon') return [geometry.coordinates[0].map((coord) => [coord[0], coord[1]])];
    if (geometry.type === 'MultiPolygon') return geometry.coordinates.map((poly) => [poly[0].map((coord) => [coord[0], coord[1]])]);
    throw new Error(`Unsupported geometry type: ${geometry.type}`);
  };
  const selectedKeyRef = useRef(selectedKey);
  const selectedNumericRef = useRef(selectedMetric);

  useEffect(() => {
    selectedKeyRef.current = selectedKey;
  }, [selectedKey]);

  useEffect(() => {
    selectedNumericRef.current = selectedMetric;
  }, [selectedMetric]);

  const handleMetricClick = async ({ metric, isNumeric }) => {
    if (isNumeric) {
      setSelectedMetric(metric);
    } else {
      setSelectedKey(metric);
      setLandKeySelectedKey(metric);
    };
  };

  if (!longstandingGeoJSONRef.current) {
    noData = true;
  } else {
    noData = false;
  }

  const [openNumericMetric, setOpenNumericMetric] = useState(null);
  const [openStringMetric, setOpenStringMetric] = useState(null);

  let orangeColor = '#c97b06';

  // TODO

  useEffect(() => {
    if (!multuGroupSelectedArray || !Array.isArray(multuGroupSelectedArray) || !longstandingGeoJSONRef.current || !originalGeoJSONforComparingRef.current || longstandingGeoJSONRef.current.features.length === 0) return;
    if (multuGroupSelectedArray.length === 1) {
      setActiveTab("GROUP");
    } else {
      setActiveTab("TOTAL");
    }
    if (multuGroupSelectedArray.length === 0) {
      setClickedInfoTab("DATA")
      polygonCustomLayerRef.current?.resetfeatureOpacities(fmesh);
    }
  }, [multuGroupSelectedArray, longstandingGeoJSONRef.current, originalGeoJSONforComparingRef.current]);

  // INFO SECTION

  useEffect(() => {
    if (multuGroupSelectedArray.length > 1) {
      setClickedInfoTab("DATA");
    }
  }, [multuGroupSelectedArray]);

  return (
    <>
      <button className="togglerRightDrawInside" onClick={toggleDrawer}>
        <IoIosArrowBack />
      </button>

      <Drawer
        open={isRighdivrawerVisible}
        direction="right"
        className="rightSubMenu"
        enableOverlay={false}
        duration={250}
      >
        <div
          style={{
            display: "flex",
            marginTop: "125px",
            marginLeft: "10px",
            marginRight: "10px",
            border: multuGroupSelectedArray.length === 1 ? "1px solid #29645D" : "1px solid transparent",
            borderRadius: "3px",
            overflow: "hidden"
          }}
        >
          {multuGroupSelectedArray.length === 1 && (
            <>
              <button
                onClick={() => setClickedInfoTab("DATA")}
                style={{
                  flex: 1,
                  padding: "5px",
                  border: "none",
                  background: clickedInfoTab === "DATA" ? "#29645D" : "#deefe7",
                  color: clickedInfoTab === "DATA" ? "#fff" : "#29645D",
                  fontWeight: "bold",
                  fontSize: '16px'
                }}
              >
                <MdBarChart />
              </button>

              <button
                onClick={() => setClickedInfoTab("INFO")}
                style={{
                  flex: 1,
                  padding: "5px",
                  border: "none",
                  background: clickedInfoTab === "INFO" ? "#29645D" : "#deefe7",
                  color: clickedInfoTab === "INFO" ? "#fff" : "#29645D",
                  fontWeight: "bold",
                  fontSize: '16px'
                }}
              >
                <IoIosInformationCircleOutline />
              </button>

              <button
                onClick={() => setClickedInfoTab("FILES")}
                style={{
                  flex: 1,
                  padding: "5px",
                  border: "none",
                  background: clickedInfoTab === "FILES" ? "#29645D" : "#deefe7",
                  color: clickedInfoTab === "FILES" ? "#fff" : "#29645D",
                  fontWeight: "bold",
                  fontSize: '16px'
                }}
              >
                <FaRegFileImage />
              </button>

              <button
                onClick={() => setClickedInfoTab("NOTES")}
                style={{
                  flex: 1,
                  padding: "5px",
                  border: "none",
                  background: clickedInfoTab === "NOTES" ? "#29645D" : "#deefe7",
                  color: clickedInfoTab === "NOTES" ? "#fff" : "#29645D",
                  fontWeight: "bold",
                  fontSize: '16px'
                }}
              >
                <CgNotes />
              </button>
            </>
          )}

        </div>

        {/* INFO TAB */}

        {multuGroupSelectedArray.length < 2 && (
          <>
            {clickedInfoTab === "INFO" &&
              multuGroupSelectedArray.length < 2 && (
                <div
                  style={{
                    height: "calc(100% - 220px)",
                    marginTop: "10px",
                    overflow: "scroll",
                  }}
                >
                  <MapMetaOrFeatureDataSimple
                    multuGroupSelectedArray={multuGroupSelectedArray}
                    mapOverview={mapOverview}
                    longstandingGeoJSONRef={longstandingGeoJSONRef}
                    globalState={globalState}
                  />
                </div>
              )}
          </>
        )}

        {/* DATA TAB */}

        <YearDropdown
          selectedMetric={selectedMetric}
          isModifying={isModifying}
          selectedYearEditing={selectedYearEditing}
          globalState={globalState}
          globalRefs={globalRefs}
          setSelectedYearEditing={setSelectedYearEditing}
          ResetMap={ResetMap}
        />

        {clickedInfoTab === "DATA" && (
          <div
            className="clicked_info"
            ref={TotalsRef}
            style={{
              height:
                multuGroupSelectedArray.length < 2
                  ? "calc(100% - 220px)"
                  : "calc(100% - 220px)"
            }}
          >
            <BrowserView>

              {activeTab === "TOTAL" && (
                <div className="clicked_info_inner" style={{ paddingTop: "125px", paddingRight: "10px" }}>
                  <b style={{ fontSize: '14px' }}>
                    Summarising {" "}
                    {(multuGroupSelectedArray?.length ?? 0) === 0
                      ? "all " + longstandingGeoJSONRef.current?.features.length
                      : multuGroupSelectedArray.length}{" "}
                    Features
                  </b>

                  <button
                    style={{
                      backgroundColor: '#fff',
                      border: 'solid #29645D 1px',
                      color: '#29645D',
                      paddingTop: '5px',
                      paddingBottom: '5px',
                      width: '55px',
                      borderRadius: '3px',
                      fontSize: '10px',
                      float: 'right'
                    }}
                    onClick={() => setShowFilterFeatureDataSimpleTimeseriesModal(true)}
                  >
                    <IoFilter />
                  </button>

                  <br />
                  <br />

                  <div style={{
                    width: '100%',
                    backgroundColor: '#29645D',
                    height: '1px',
                  }}></div>

                  {/* NUMERIC METRICS */}
                  <div style={{ marginBottom: "10px", marginTop: '13px' }}>

                    <div
                      className="setNumericAggregationMethod"
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        height: '20px',
                        width: '70%',
                        position: 'relative',
                        top: '-5px',
                        right: '0px',
                        float: 'right'
                      }}
                    >

                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          gap: '6px',
                          alignItems: 'center'
                        }}
                      >
                        <button
                          style={{
                            backgroundColor:
                              numericAggregationMethod === 'avg' ? '#29645D' : '#fff',
                            border: 'solid #29645D 1px',
                            color:
                              numericAggregationMethod === 'avg' ? '#fff' : '#29645D',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '55px',
                            borderRadius: '3px',
                            fontSize: '10px'
                          }}
                          onClick={() => setNumericAggregationMethod('avg')}
                        >
                          Avg
                        </button>

                        <button
                          style={{
                            backgroundColor:
                              numericAggregationMethod === 'sum' ? '#29645D' : '#fff',
                            border: 'solid #29645D 1px',
                            color:
                              numericAggregationMethod === 'sum' ? '#fff' : '#29645D',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '55px',
                            borderRadius: '3px',
                            fontSize: '10px'
                          }}
                          onClick={() => setNumericAggregationMethod('sum')}
                        >
                          Sum
                        </button>

                        <button
                          style={{
                            backgroundColor:
                              numericAggregationMethod === 'avg_by_area' ? '#29645D' : '#fff',
                            border: 'solid #29645D 1px',
                            color:
                              numericAggregationMethod === 'avg_by_area' ? '#fff' : '#29645D',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '55px',
                            borderRadius: '3px',
                            fontSize: '10px'
                          }}
                          onClick={() => setNumericAggregationMethod('avg_by_area')}
                        >
                          Area Avg
                        </button>

                        {/* <IoIosArrowDown
                          style={{
                            position: 'absolute',
                            right: '6px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#29645D',
                            fontSize: '12px',
                            pointerEvents: 'none'
                          }}
                        /> */}
                      </div>
                    </div>

                    <p style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: '#29645D',
                      marginBottom: '12px'
                    }}>
                      Values
                    </p>

                    {[...availableNumericMetrics]
                      .filter((metric) => {
                        const order =
                          mapMetaData?.define_feature_data_simple_timeseries?.[metric]?.display_order;
                        return order !== -1;
                      })
                      .sort((a, b) => {
                        const nameA =
                          mapMetaData?.define_feature_data_simple_timeseries?.[a]?.name || a;

                        const nameB =
                          mapMetaData?.define_feature_data_simple_timeseries?.[b]?.name || b;

                        return nameA.localeCompare(nameB, undefined, {
                          sensitivity: 'base'
                        });
                      })
                      .map((metric) => {
                        const isOpen = openNumericMetric === metric;

                        const rawMeta =
                          mapMetaData?.define_feature_data_simple_timeseries?.[metric] || {};

                        const meta = {
                          ...rawMeta,
                          display_hint: rawMeta.display_hint ?? "chartdata_line",
                        };

                        return (
                          <MetricItem
                            key={metric}
                            metric={metric}
                            isNumeric={true}
                            isOpen={isOpen}
                            meta={meta}
                            setOpenNumericMetric={setOpenNumericMetric}
                            handleMetricClick={handleMetricClick}
                            selectedMetric={selectedMetric}
                            selectedKey={selectedKey}
                            numericSummary={numericSummary}
                            keySummary={keySummary}
                            selectedYearEditing={selectedYearEditing}
                            selectedRange={selectedRange}
                            setSelectedYearEditing={setSelectedYearEditing}
                            availableDates={availableDates}
                            marks={marks}
                            toIsoWithOffset={toIsoWithOffset}
                            numericTimeAggregationMethod={numericTimeAggregationMethod}
                            IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
                          />
                        );
                      })}
                  </div>

                  {/* CATEGORY METRICS */}
                  <div>

                    <div
                      className="setNumericAggregationMethod"
                      style={{
                        display: 'flex',
                        height: '20px',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        position: 'relative',
                        top: '-5px',
                        float: 'right'
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: orangeColor,
                          border: orangeColor,
                          color: '#fff',
                          paddingTop: '5px',
                          paddingBottom: '5px',
                          width: '55px',
                          borderRadius: '3px',
                          fontSize: '10px'
                        }}
                      >
                        Sum
                      </button>
                    </div>

                    <p style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: '#29645D',
                      margin: '5px 0px 10px 0px',
                    }}>
                      Categories
                    </p>

                    {[...availableStringMetrics]
                      .filter((metric) => {
                        const order =
                          mapMetaData?.define_feature_data_simple_timeseries?.[metric]?.display_order;
                        return order !== -1;
                      })
                      .sort((a, b) => {
                        const nameA =
                          mapMetaData?.define_feature_data_simple_timeseries?.[a]?.name || a;

                        const nameB =
                          mapMetaData?.define_feature_data_simple_timeseries?.[b]?.name || b;

                        return nameA.localeCompare(nameB, undefined, {
                          sensitivity: 'base'
                        });
                      })
                      .map((metric) => {
                        const isOpen = openStringMetric === metric;

                        const rawMeta =
                          mapMetaData?.define_feature_data_simple_timeseries?.[metric] || {};

                        const meta = {
                          ...rawMeta,
                          display_hint: rawMeta.display_hint ?? null,
                        };

                        return (
                          <MetricItem
                            key={metric}
                            metric={metric}
                            isNumeric={false}
                            isOpen={isOpen}
                            meta={meta}
                            setOpenStringMetric={setOpenStringMetric}
                            handleMetricClick={handleMetricClick}
                            selectedMetric={selectedMetric}
                            selectedKey={selectedKey}
                            numericSummary={numericSummary}
                            keySummary={keySummary}
                            selectedYearEditing={selectedYearEditing}
                            setSelectedYearEditing={setSelectedYearEditing}
                            availableDates={availableDates}
                            marks={marks}
                            toIsoWithOffset={toIsoWithOffset}
                            longstandingGeoJSONRef={longstandingGeoJSONRef}
                            polygonCustomLayerRef={polygonCustomLayerRef}
                            multuGroupSelectedArray={multuGroupSelectedArray}
                            setMultuGroupSelectedArray={setMultuGroupSelectedArray}
                            setGlobalPolygonTransparency={setGlobalPolygonTransparency}
                            IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
                          />
                        );
                      })}
                  </div>

                </div>
              )}

              {activeTab === "GROUP" && (
                <div className='clicked_info_inner'>
                  {multuGroupSelectedArray.length === 1 ? (
                    <>
                      <ClickedInfoRealm
                        longstandingGeoJSONRef={longstandingGeoJSONRef}
                        universalParcelDifferentiator={
                          universalParcelDifferentiator
                        }
                        universalColorPaletteName={
                          universalColorPaletteName
                        }
                        landKeySelectedKey={landKeySelectedKey}
                        setLandKeySelectedKey={setLandKeySelectedKey}
                        globalState={globalState}
                        globalRefs={globalRefs}
                        isRealmLeftClickedInfoVisible={
                          isRealmLeftClickedInfoVisible
                        }
                        setIsRealmLeftClickedInfoVisible={
                          setIsRealmLeftClickedInfoVisible
                        }
                        selectedYearEditing={selectedYearEditing}
                        ResetMap={ResetMap}
                        polygonCustomLayerRef={polygonCustomLayerRef}
                        featureList={featureList}
                        setFeatureList={setFeatureList}
                        activeFeatureId={activeFeatureId}
                        setActiveFeatureId={setActiveFeatureId}
                      />
                    </>
                  ) : (
                    <>
                      <div className="clicked_info_inner_inner" >

                        <div style={{
                          paddingTop: '220px',
                          paddingLeft: '10px',
                          width: 'calc(100% - 21px)',
                          height: '118px',
                        }} >
                          Please Select a Parcel to begin viewing Group information
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}
            </BrowserView>
          </div >
        )}

        {/* FILES TAB */}

        {
          clickedInfoTab === "FILES" && (
            <div
              style={{
                padding: "20px",
                color: "#29645D",
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "40px"
              }}
            >
              <span style={{
                border: '1px solid #222',
                padding: '10px',
                borderRadius: '3px',
                backgroundColor: 'rgb(222, 239, 231)'
              }}>Files Feature Currently in development
              </span>
            </div>
          )
        }

        {/* NOTES TAB */}

        {
          clickedInfoTab === "NOTES" && (
            <div
              style={{
                padding: "20px",
                color: "#29645D",
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "40px"
              }}
            >
              <span style={{
                border: '1px solid #222',
                padding: '10px',
                borderRadius: '3px',
                backgroundColor: 'rgb(222, 239, 231)'
              }}>Notes Feature Currently in development
              </span>
            </div>
          )
        }

        <button className='togglerRightDrawOutside' onClick={toggleDrawer}>
          <IoIosArrowForward />
        </button>
      </Drawer >
    </>

  );
};

export default ClickedInfo;
